import type { $ZodIssue } from 'zod/v4/core'

// Warning the argument will be mutated
export default function flattenZodErrors(errors: $ZodIssue[]): $ZodIssue[] {
  const zodErrors: $ZodIssue[] = []
  while (errors.length) {
    const error = errors[0]!
    if (error.code === 'invalid_union' && error.errors.length) {
      for (const unionError of error.errors) {
        for (const innerError of unionError) {
          zodErrors.push(innerError)
        }
      }
    } else {
      zodErrors.push(error)
    }
    errors.shift()
  }
  return zodErrors
}
